import { apiPrefixes } from '@/api/apiPrefixes'
import { ResultType, httpWithCookie, toLogin } from '@/utils'
import {
  ShareTalentMember,
  ShareTalentParam
} from '@/interfaces/shareTalentModel'
import {
  SingleTalentMember,
  SingleTalentParam
} from '@/interfaces/singleTalentModel'
import { DataWithId } from '@/interfaces/baseconfig'

const api = {
  // 共享人才查询列表
  querySharingTalentList: `${apiPrefixes.ehrapi}/api/rkhy/sharingTalent/queryList.do`,
  // 达人查询列表
  queryRecruitMicroList: `${apiPrefixes.ehrapi}/api/rkhy/recruitMicro/queryList.do`,

  // 查询是否店总
  queryRecruitCity: `${apiPrefixes.ehrapi}/api/rkhy/recruitMicro/getStoreCityByLogin.do`
}

const querySharingTalentList = async (
  params: ShareTalentParam,
  requestid: string
): Promise<DataWithId<ShareTalentMember[]>> => {
  const result = await httpWithCookie.post<
    any,
    ResultType<{ list: ShareTalentMember[] }>
  >(api.querySharingTalentList, params)
  const { code, data } = result
  if (code === '1') {
    return { data: data?.list || [], requestid: requestid }
  } else if (+code == 1024) {
    toLogin()
    return { requestid: requestid }
  } else {
    return { requestid: requestid }
  }
}

const queryRecruitMicroList = async (
  params: SingleTalentParam,
  requestid: string
): Promise<DataWithId<SingleTalentMember[]>> => {
  const result = await httpWithCookie.post<
    any,
    ResultType<{ list: SingleTalentMember[] }>
  >(api.queryRecruitMicroList, params)

  const { code, data } = result
  if (code === '1') {
    return { data: data?.list || [], requestid: requestid }
  } else if (+code == 1024) {
    toLogin()
    return { requestid: requestid }
  } else {
    return { requestid: requestid }
  }
}

const queryRecruitCity = async (): Promise<any> => {
  const result: any = await httpWithCookie.post(api.queryRecruitCity)
  const { code, data } = result
  if (code === '1') {
    return data
  } else if (+code == 1024) {
    return toLogin()
  }
  return Promise.reject()
}

export const talent = {
  querySharingTalentList,
  queryRecruitMicroList,
  queryRecruitCity
}
